export const CLIENT_BALANCE_MAX = 99999999999.99;

export const MAX_FIELD_LENGTH_5000 = 5000;
export const INSTAGRAM_MAX_MESSAGE_LENGTH = 998;
export const AI_PROMPT_MAX_LENGTH = 6000;
